import _ from 'lodash';
import { helperGetPersonalityUrl } from 'helpers/RouteHelper';
import Regex from 'helpers/Regex';
import {
  PANEL_TYPE_CAST,
  PANEL_TYPE_CLIPS,
  PANEL_TYPE_EPISODES,
  getTabPageId,
  getTabName,
  isTabGrouped,
} from './SeriesDetailHelpers';

export const getPersonalityTabSlug = ({ tab, tabs, noTabHomepage, seriesType }) => {
  if (!tab) return null;
  const { '@type': type, seasonNumber } = tab;
  const headline = getTabName({ tab, seriesType });

  if (tab && tabs) {
    if (!noTabHomepage && tabs.indexOf(tab) === 0) {
      return '';
    }
    const tabType = _.get(tab, '@type', null);
    const firstTabType = _.get(tabs, '0.@type', null);
    if (tabType === firstTabType && isTabGrouped({ tabType, seriesType })) {
      return tabType === PANEL_TYPE_EPISODES ? `season-${seasonNumber}` : '';
    }
  }
  if (type === PANEL_TYPE_CLIPS) return 'clips';
  if (type === PANEL_TYPE_EPISODES) return 'episodes';
  if (type === PANEL_TYPE_CAST) return 'credits';
  if (!headline) return null;
  return headline
    .toString()
    .toLowerCase()
    .replace(Regex.SPACES, '-') // Replace spaces with -
    .replace(Regex.NON_WORD_CHARACTERS, '') // Remove all non-word chars
    .replace(Regex.MULTIPLE_DASHES, '-') // Replace multiple - with single -
    .replace(Regex.LEADING_DASH, '') // Trim - from start of text
    .replace(Regex.TRAILING_DASH, ''); // Trim - from end of text;
};

export const getPersonalityTabUrl = ({
  showId,
  tab,
  tabs,
  noTabHomepage,
  seriesType,
  isSubmenu,
  isPersonality,
}) => {
  const tabSlug = getPersonalityTabSlug({
    tab,
    tabs,
    noTabHomepage,
    seriesType,
    isSubmenu,
    isPersonality,
  });
  const tabPageId = getTabPageId({ noTabHomepage, tab, tabs });
  let url = helperGetPersonalityUrl(showId);
  if (tabSlug) url = `${url}${tabSlug}${tabPageId}/`;
  return url;
};
